import React from 'react';
import { Paper, Typography } from '@mui/material';

interface SectionPaperProps {
  title: string;
  children: React.ReactNode;
  mb?: number;
}

export const SectionPaper: React.FC<SectionPaperProps> = ({
  title,
  children,
  mb = 4,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        mb,
        p: 4,
        borderRadius: 3,
        background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
        boxShadow: '20px 20px 60px #d9d9d9, -20px -20px 60px #ffffff',
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: '#1a237e', mb: 3 }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
};
